export default ({ socket, uri, content: defaultContent }) =>
  (method, content) => socket.send({
    uri,
    method,
    content: {
      ...defaultContent,
      ...content,
    },
  });
